(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq-video"] && !Shopify.designMode) return;
  try {
    
  class FAQVideoSection {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.playBtn = this.section.querySelector('.faq-video__play-btn');
      this.overlay = this.section.querySelector('.faq-video__overlay');
      this.videoElement = this.section.querySelector('.faq-video__video-element');
      this.iframeElement = this.section.querySelector('.faq-video__iframe');

      if (this.playBtn) {
        this.playBtn.addEventListener('click', () => this.playVideo());
      }

      this.setupAccordion();
    }

    // Smoothly animate <details> open/close height, single row open at a time.
    setupAccordion() {
      this.rows = Array.from(this.section.querySelectorAll('.custom-faq-video__row'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.rows.forEach((row) => {
        const summary = row.querySelector('.custom-faq-video__summary');
        const answer = row.querySelector('.custom-faq-video__answer');
        if (!summary || !answer) return;

        let animation = null;

        const collapsedHeight = () => {
          const cs = getComputedStyle(row);
          const padding = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
          return summary.offsetHeight + padding;
        };

        const cleanup = (open) => {
          row.open = open;
          animation = null;
          row.style.height = '';
          row.style.overflow = '';
        };

        const animateTo = (startHeight, endHeight, open) => {
          if (animation) animation.cancel();
          if (reduceMotion) {
            cleanup(open);
            return;
          }
          row.style.overflow = 'hidden';
          animation = row.animate(
            { height: [`${startHeight}px`, `${endHeight}px`] },
            { duration: 380, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
          );
          animation.onfinish = () => cleanup(open);
          animation.oncancel = () => { animation = null; };
        };

        const expand = () => {
          const startHeight = row.offsetHeight;
          row.open = true; // reveal content to measure full height
          const endHeight = row.offsetHeight;
          row.style.height = `${startHeight}px`;
          requestAnimationFrame(() => animateTo(startHeight, endHeight, true));
        };

        const shrink = () => {
          const startHeight = row.offsetHeight;
          animateTo(startHeight, collapsedHeight(), false);
        };
        row._cfvShrink = () => { if (row.open) shrink(); };

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          if (row.open) {
            shrink();
            return;
          }

          // Close any other open rows with the same smooth animation.
          this.rows.forEach((other) => {
            if (other !== row && other.open && other._cfvShrink) {
              other._cfvShrink();
            }
          });
          expand();
        });
      });
    }

    playVideo() {
      // Hide overlay
      if (this.overlay) {
        this.overlay.classList.add('faq-video__overlay--hidden');
      }

      // Play HTML5 video element
      if (this.videoElement) {
        this.videoElement.classList.add('faq-video__video--active');
        this.videoElement.setAttribute('controls', 'true');
        this.videoElement.play();
      }

      // Play Youtube/Vimeo iframe
      if (this.iframeElement) {
        this.iframeElement.classList.add('faq-video__iframe--active');
        let src = this.iframeElement.getAttribute('src');
        if (src.indexOf('autoplay=') === -1) {
          src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&mute=0';
          this.iframeElement.setAttribute('src', src);
        }
      }
    }
  }

  // Initialize for all FAQ sections on the page
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.custom-faq-video').forEach((section) => {
      new FAQVideoSection(section);
    });
  });

  // Hot-reloading in Shopify Theme Editor
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.custom-faq-video');
    if (section) {
      new FAQVideoSection(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials-media"] && !Shopify.designMode) return;
  try {
    
  class TestimonialSlider {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.track = this.section.querySelector('.custom-testimonials__track');
      this.cards = this.section.querySelectorAll('.custom-testimonials__card');
      this.prevBtn = this.section.querySelector('.custom-testimonials__nav-btn--prev');
      this.nextBtn = this.section.querySelector('.custom-testimonials__nav-btn--next');
      this.counter = this.section.querySelector('.custom-testimonials__counter');

      this.currentIndex = 1;
      this.totalSlides = this.cards.length;

      if (this.totalSlides === 0) return;

      // Bind Event Listeners
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.slidePrev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.slideNext());

      this.resizeHandler = () => this.updateSlider();
      window.addEventListener('resize', this.resizeHandler);

      this.initVideoPlayers();
      this.updateSlider();
    }

    initVideoPlayers() {
      this.cards.forEach((card) => {
        const playBtn = card.querySelector('.custom-testimonials__play-btn');
        const overlay = card.querySelector('.custom-testimonials__media-overlay');
        const videoElement = card.querySelector('.custom-testimonials__video-element');
        const iframeElement = card.querySelector('.custom-testimonials__iframe');

        if (playBtn) {
          playBtn.addEventListener('click', () => {
            if (overlay) {
              overlay.classList.add('custom-testimonials__media-overlay--hidden');
            }
            if (videoElement) {
              videoElement.classList.add('custom-testimonials__video--active');
              videoElement.setAttribute('controls', 'true');
              videoElement.play();
            }
            if (iframeElement) {
              iframeElement.classList.add('custom-testimonials__iframe--active');
              let src = iframeElement.getAttribute('src');
              if (src.indexOf('autoplay=') === -1) {
                src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&mute=0';
                iframeElement.setAttribute('src', src);
              }
            }
          });
        }
      });
    }

    slidePrev() {
      if (this.currentIndex > 1) {
        this.currentIndex--;
        this.updateSlider();
      }
    }

    slideNext() {
      const maxSlides = this.getMaxSlides();
      if (this.currentIndex < maxSlides) {
        this.currentIndex++;
        this.updateSlider();
      }
    }

    getMaxSlides() {
      const isDesktop = window.innerWidth >= 990;
      if (isDesktop) {
        return Math.max(1, this.totalSlides - 1);
      }
      return this.totalSlides;
    }

    updateSlider() {
      const maxSlides = this.getMaxSlides();
      if (this.currentIndex > maxSlides) {
        this.currentIndex = maxSlides;
      }
      if (this.currentIndex < 1) {
        this.currentIndex = 1;
      }

      const isDesktop = window.innerWidth >= 990;
      if (this.totalSlides > 1) {
        if (isDesktop) {
          const offsetPct = 50 * (this.currentIndex - 1);
          const offsetPx = 15 * (this.currentIndex - 1);
          this.track.style.transform = `translateX(calc(-${offsetPct}% - ${offsetPx}px))`;
        } else {
          const offsetPct = 100 * (this.currentIndex - 1);
          const offsetPx = 30 * (this.currentIndex - 1);
          this.track.style.transform = `translateX(calc(-${offsetPct}% - ${offsetPx}px))`;
        }
      } else {
        this.track.style.transform = 'translateX(0)';
      }

      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 1;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentIndex === maxSlides;
      }

      if (this.counter) {
        const currentStr = String(this.currentIndex).padStart(2, '0');
        const totalStr = String(this.totalSlides).padStart(2, '0');
        this.counter.textContent = `${currentStr} / ${totalStr}`;
      }
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.custom-testimonials').forEach((section) => {
      new TestimonialSlider(section);
    });
  });

  // Hot-reloading in Shopify Theme Editor
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.custom-testimonials');
    if (section) {
      new TestimonialSlider(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-trust-badges-slider"] && !Shopify.designMode) return;
  try {
    
  class TrustBadgesSlider {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.track = this.section.querySelector('.custom-trust-badges__list');
      this.dots = this.section.querySelectorAll('.custom-trust-badges__dot');
      
      if (!this.track || this.dots.length === 0) return;

      this.scrollHandler = () => this.updateDots();
      this.track.addEventListener('scroll', this.scrollHandler);

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const itemWidth = this.track.clientWidth;
          this.track.scrollTo({
            left: itemWidth * index,
            behavior: 'smooth'
          });
        });
      });
    }

    updateDots() {
      const scrollLeft = this.track.scrollLeft;
      const width = this.track.clientWidth;
      const activeIndex = Math.round(scrollLeft / width);
      
      this.dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('custom-trust-badges__dot--active');
        } else {
          dot.classList.remove('custom-trust-badges__dot--active');
        }
      });
    }

    destroy() {
      if (this.track && this.scrollHandler) {
        this.track.removeEventListener('scroll', this.scrollHandler);
      }
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.custom-trust-badges').forEach((section) => {
      new TrustBadgesSlider(section);
    });
  });

  // Hot-reloading in Shopify Theme Editor
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.custom-trust-badges');
    if (section) {
      new TrustBadgesSlider(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
